import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseContractSignedTemplates = [
  {
    id: '-110001',
    language: Language.EN,
    subject: 'Lease contract signed',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: the lease located at <strong>{{getLeaseMainAddress lease}}</strong> is signed.</p>
        <p></p>
        <p>Your lease contract has been signed by all stakeholders.</p>
        <p>Please find all signed documents attached.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-110002',
    language: Language.FR,
    subject: 'Contrat de bail signé',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: le bail sis <strong>{{getLeaseMainAddress lease}}</strong> a été signé par toutes les parties.</p>
        <p></p>
        <p>Votre contrat de bail a été signé par toutes les parties.</p>
        <p>Nous vous prions de trouver l'ensemble des documents signés en pièce jointe.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-110003',
    language: Language.NL,
    subject: 'Huurcontract ondertekend',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong> werd door alle partijen ondertekend.</p>
        <p></p>
        <p>Uw huurcontract werd door alle partijen ondertekend.</p>
        <p>Alle ondertekende documenten vindt u in bijlage.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
    `,
  },
  {
    id: '-110004',
    language: Language.DE,
    subject: 'Mietvertrag unterzeichnet',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Der Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong> ist unterzeichnet.</p>
        <p></p>
        <p>Ihr Mietvertrag wurde von allen Beteiligten unterzeichnet.</p>
        <p>Bitte finden Sie alle unterzeichneten Dokumente im Anhang.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
